import { render, staticRenderFns } from "./QuizResultsTable.vue?vue&type=template&id=4b543082"
import script from "./QuizResultsTable.vue?vue&type=script&lang=js"
export * from "./QuizResultsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports